var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimbolomovil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 40,
    viewBox: "0 0 139 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1838 0H37.4048L17.4062 39.5732H0L20.1838 0Z",
    fill: "#15205A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.256 0H76.9779L57.5589 39.5732H40.6572L60.256 0Z",
    fill: "#15205A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.249 0H118.72L98.4311 39.5732H80.7726L101.249 0Z",
    fill: "#15205A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5281 0H20.0574L40.3459 39.5732H58.0044L37.5281 0Z",
    fill: "#4172C7",
    fillOpacity: 0.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.521 0H61.7991L81.2181 39.5732H98.1198L78.521 0Z",
    fill: "#4172C7",
    fillOpacity: 0.85
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.594 0H101.372L121.371 39.5732H138.777L118.594 0Z",
    fill: "#4172C7",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimbolomovil);
export default __webpack_public_path__ + "static/media/simbolomovil.b1f0c48d49d1c098b292a1a0b72188db.svg";
export { ForwardRef as ReactComponent };